export default __webpack_public_path__ + "static/media/hero-img.520a4428.PNG";